import React, {Fragment, useState, useContext} from 'react';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';

import {
    FacebookIcon,
    FacebookMessengerIcon,
    WhatsappIcon,
    EmailIcon,
    EmailShareButton,
    FacebookShareButton,
    FacebookMessengerShareButton,
    WhatsappShareButton,
} from "react-share";
import CheckIcon from '@material-ui/icons/Check';
import { ReactComponent as NextStepsSvg } from '../../assets/next-steps.svg';
import {ProviderRequestsContext} from "../../context/ProviderRequestsContext";

export default function NextSteps(props) {
    const { classes } = props;
    const providerRequestsContext = useContext(ProviderRequestsContext);
    const inviteTitle = providerRequestsContext.state.inviteTitle;
    const inviteUrl = providerRequestsContext.state.inviteUrl;
    const [copySuccess, setCopySuccess] = useState('');
    const hideCopySuccess = () => {
        setTimeout( () => {
            setCopySuccess('');
            }, 2000);
        return false;
    }
    const handleCopy = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(inviteUrl);
        setCopySuccess('copied');
        hideCopySuccess();
    }

    return (
        <Fragment>
            <Grid container spacing={2} noValidate className={classes.inputContainer}>
                <Grid item sm={12} className={`${classes.noPadding}`}>
                    <NextStepsSvg className={`${classes.center} ${classes.img}`} />
                    <Paper square elevation={0} className={classes.inputTitleContainer}>
                        <Typography className={classes.inputTitleText}>Verifică statusul furnizorilor</Typography>
                        <Typography className={`${classes.mb8} ${classes.subTitle}`}>Verifică statusul furnizorilor în contul tău my-invite.ro</Typography>
                    </Paper>
                    <Button
                        variant="contained"
                        color="primary"
                        className={`${classes.fullWidthButton} ${classes.mb70}`}
                    >
                        <Link href={`${process.env.REACT_APP_BACKEND_BASE_URL}/dashboard-invitatiile-mele`} color="secondary">
                            CONTUL MEU
                        </Link>
                    </Button>
                </Grid>
                <Grid item sm={12} className={classes.inviteDownloadContainer}>
                    <Paper square elevation={0} className={classes.inputTitleContainer}>
                        <Typography className={classes.inputTitleText}>Distribuie invitația</Typography>
                    </Paper>
                    <Paper square elevation={0} className={`${classes.smIconsContainer} ${classes.wrapFields}`}>
                        <EmailShareButton subject={inviteTitle} url={inviteUrl}>
                            <EmailIcon size={32} round={true}  />
                        </EmailShareButton>
                        <span> </span>
                        <FacebookShareButton quote={inviteTitle} url={inviteUrl}>
                            <FacebookIcon size={32} round={true} />
                        </FacebookShareButton>
                        <span> </span>
                        <FacebookMessengerShareButton quote={inviteTitle} url={inviteUrl}>
                            <FacebookMessengerIcon size={32} round={true} />
                        </FacebookMessengerShareButton>
                        <span> </span>
                        <WhatsappShareButton title={inviteTitle} url={inviteUrl}>
                            <WhatsappIcon size={32} round={true} />
                        </WhatsappShareButton>
                    </Paper>
                </Grid>
                <Grid item sm={12} className={`${classes.noPadding} ${classes.linkContainer}`}>
                    <Paper square elevation={0} className={`${classes.inputFieldContainer} ${classes.copyContainer}`}>
                        <Typography>{inviteUrl}</Typography>
                        { document.queryCommandSupported('copy') &&
                            <Button className={classes.copyBtn} onClick={handleCopy} endIcon={copySuccess && <CheckIcon />}>Copy</Button>
                        }
                    </Paper>
                </Grid>
            </Grid>
        </Fragment>
    )
}